import { Table, TableCell, TableRow } from 'components/common/minimalTable'
import { ItemReplacementLog } from 'types/order'
import { formatDate } from 'utils/helpers/date'

/**
 * Item replacements made on this order by a store-app picker.
 *
 * The order's product lines only show what they are NOW, so this table is the
 * only place the admin can see what the customer originally ordered and what
 * was put in its place.
 */
interface ItemReplacementHistoryProps {
  replacementLogs: ItemReplacementLog[]
}

// Prices are stored to 4 decimals; 2 is what every other money column shows.
const formatPrice = (price?: number) => Number(price ?? 0).toFixed(2)

const ItemReplacementList = ({
  replacementLogs,
}: ItemReplacementHistoryProps) => (
  <Table
    headers={[
      'Original Barcode',
      'Original Qty',
      'Original Price',
      'Replaced Barcode',
      'Replaced Qty',
      'Replaced Price',
      'Picker',
      'Picker ID',
      'Employee ID',
      'Created Date',
    ]}
  >
    {replacementLogs.map((log: ItemReplacementLog) => (
      <TableRow key={log._id}>
        <TableCell>{log?.originalBarcode ?? '-'}</TableCell>
        <TableCell>{log?.originalQty ?? '-'}</TableCell>
        <TableCell>{formatPrice(log?.originalPrice)}</TableCell>
        <TableCell>{log?.replacedBarcode ?? '-'}</TableCell>
        <TableCell>{log?.replacedQty ?? '-'}</TableCell>
        <TableCell>{formatPrice(log?.replacedPrice)}</TableCell>
        {/* Stored on the log; older logs hold a User _id as pickerId. */}
        <TableCell>{log?.pickerName || '-'}</TableCell>
        <TableCell>{log?.pickerId || '-'}</TableCell>
        <TableCell>{log?.empId || '-'}</TableCell>
        <TableCell>
          {log?.createdAt
            ? formatDate(log.createdAt, { includeTime: true })
            : '-'}
        </TableCell>
      </TableRow>
    ))}
  </Table>
)

const TableItemReplacementHistory = ({
  replacementLogs,
}: ItemReplacementHistoryProps) => {
  return (
    <>
      <h3 className="title mt-3">Item Replacement History</h3>

      {replacementLogs?.length > 0 ? (
        <ItemReplacementList replacementLogs={replacementLogs} />
      ) : (
        <p className="text-sm text-gray-600">
          No item replacements on this order
        </p>
      )}
    </>
  )
}

export default TableItemReplacementHistory
